<article class="section-inset-b event-detail" *ngIf="event$ | async as event">
  <app-event-header [event]="event">
    <app-breadcrumbs class="d-block mb-3" [breadcrumbs]="breadcrumbs" slot="breadcrumbs"></app-breadcrumbs>
  </app-event-header>
  <div class="container section-inset-b pt-event-header">
    <main class="text-max-width-xs mx-auto">
      <!-- For owner -->
      <ng-container *ngIf="event.createdById === (user$ | async)?.id || (user$ | async | requiredRole : ['Administrator'])">
        <section class="card mb-3 mt-3 mt-md-4 mb-md-5 event-detail__edit">
          <h6 class="text-primary fw-bold type-body-md font-secondary mb-4">Je bent eigenaar van deze activiteit</h6>
          <a [routerLink]="['bewerken']" class="button button--tertiary">
            <span>{{ 'evenement-bewerk-knop-label' | fromDictionary }}</span>
            <app-icon anchor="icon-edit"></app-icon>
          </a>
        </section>
        <div class="publish-alert alert alert--info d-flex align-items-center mb-3" *ngIf="!event.publish">
          <div class="me-3">
            <app-icon anchor="icon-warning"></app-icon>
          </div>
          <span [innerHTML]="previewPlaceholder$ | async"></span>
        </div>
      </ng-container>

      <div class="mx-md-0">
        <p class="lead fw-bold py-3 py-xl-4" *ngIf="event.intro">
          {{ event.intro }}
        </p>

        <!--<div
          class="markdown-content"
          fstrDynamicContent
          [innerHTML]="event?.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined | safe"
        ></div>-->

        <ngx-dynamic-hooks
          class="markdown-content"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="event?.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>

        <a *ngIf="event.externalUrl" [href]="event.externalUrl" target="_blank" class="button button--primary button--md">
          {{ event.externalUrlText }}
        </a>

        <section class="my-3 my-md-5" *ngIf="(event.dateSpans?.length || 0) > 1" id="data">
          <h2 class="text-primary mb-4">{{ 'evenement-datums-titel' | fromDictionary }}</h2>

          <ul class="event-date-list">
            <li class="event-date-list__item" *ngFor="let dateSpan of getCurrentAndOldEvents(event.dateSpans!).current">
              <app-event-date-list-item [dateSpan]="dateSpan"></app-event-date-list-item>
            </li>
            <li class="event-date-list__item" *ngFor="let dateSpan of getCurrentAndOldEvents(event.dateSpans!).old">
              <app-event-date-list-item [dateSpan]="dateSpan"></app-event-date-list-item>
            </li>
          </ul>
        </section>

        <app-content-meta-info
          *ngIf="event.locations?.length"
          [locations]="event.locations!"
          [entireArea]="event.entireArea ?? false"
          class="d-block mt-4"
        ></app-content-meta-info>
      </div>

      <section class="section-inset-y" *ngIf="event.initiative as initiative">
        <header class="mb-5">
          <span class="type-body-md fw-bold w-100 related-stories__subtitle">
            {{ 'event-detail-initiatief-subtitel' | fromDictionary }}
          </span>
          <h1 class="related-stories__title h2 text-primary">
            {{ 'event-detail-initiatief-titel' | fromDictionary }}
            <app-icon anchor="icon-squiggle" class="heading-squiggle"></app-icon>
          </h1>
        </header>
        <app-teaser-card
          [inverted]="true"
          [title]="initiative.title"
          [subtitle]="initiative.subtitle"
          [image]="initiative.image || event.image"
          [linkToContent]="initiative.url"
          [linkText]="'event-detail-intiatief-link-tekst' | fromDictionary"
        ></app-teaser-card>
      </section>
    </main>
  </div>

  <div class="overflow-hidden section-outset-y" *ngIf="(relatedContent$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedContent$ | async as relatedContent">
      <app-related-content
        [title]="'gerelateerde-content-titel' | fromDictionary"
        [content]="relatedContent"
        *ngIf="relatedContent.length"
      ></app-related-content>
    </div>
  </div>
</article>
